export default __webpack_public_path__ + "static/media/Archdeacon's Belt of the Abyss.47b8dabd.jpg";